import { render, staticRenderFns } from "./EventsShorts.vue?vue&type=template&id=17243a30&scoped=true&"
import script from "./EventsShorts.vue?vue&type=script&lang=js&"
export * from "./EventsShorts.vue?vue&type=script&lang=js&"
import style0 from "./EventsShorts.vue?vue&type=style&index=0&id=17243a30&scoped=true&lang=scss&"
import style1 from "./EventsShorts.vue?vue&type=style&index=1&v-pre=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17243a30",
  null
  
)

export default component.exports